/* SSL homepage components — Agentcy for SickScience */
(() => {
  class SslTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      if (!this.tabs.length) return;
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.select(i));
        tab.addEventListener('keydown', (e) => {
          const map = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: this.tabs.length - 1 };
          if (!(e.key in map)) return;
          e.preventDefault();
          const next = (map[e.key] + this.tabs.length) % this.tabs.length;
          this.select(next);
          this.tabs[next].focus();
        });
      });
    }

    select(index) {
      this.tabs.forEach((tab, i) => {
        const on = i === index;
        tab.setAttribute('aria-selected', String(on));
        tab.tabIndex = on ? 0 : -1;
        const panel = this.querySelector(`#${tab.getAttribute('aria-controls')}`);
        if (panel) panel.hidden = !on;
      });
    }
  }

  class SslPlanToggle extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.plan = this.form?.querySelector('input[name="selling_plan"]');
      this.addEventListener('change', () => this.update());
      this.update();
    }

    update() {
      const sub = this.querySelector('input[value="sub"]')?.checked;
      if (this.plan) this.plan.disabled = !sub;
    }
  }

  document.addEventListener('click', (e) => {
    const view = e.target.closest('[data-card-view]');
    if (view) {
      const wrap = view.closest('.ssl-bcard__mediawrap');
      if (!wrap) return;
      wrap.classList.toggle('is-results', view.dataset.cardView === 'results');
      wrap.querySelectorAll('[data-card-view]').forEach((b) => b.setAttribute('aria-pressed', String(b === view)));
      return;
    }
    const opener = e.target.closest('[data-awards-open]');
    if (opener) {
      const dialog = opener.closest('.ssl')?.querySelector('[data-awards-dialog]');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      dialog.querySelector('[data-awards-title]').textContent = `${opener.dataset.product} awards`;
      const list = dialog.querySelector('[data-awards-list]');
      list.innerHTML = '';
      (opener.dataset.awards || '').split('|').filter(Boolean).forEach((award) => {
        const li = document.createElement('li');
        li.textContent = award;
        list.append(li);
      });
      dialog.showModal();
      return;
    }
    const dialog = e.target.closest('[data-awards-dialog]');
    if (dialog && (e.target === dialog || e.target.closest('[data-awards-close]'))) dialog.close();
  });

  class SslTstatsToggle extends HTMLElement {
    connectedCallback() {
      const root = this.closest('.ssl-tstats');
      const btn = this.querySelector('button');
      if (!root || !btn) return;
      btn.addEventListener('click', () => {
        const paused = root.classList.toggle('is-paused');
        btn.setAttribute('aria-pressed', String(paused));
        btn.setAttribute('aria-label', paused ? btn.dataset.labelPlay : btn.dataset.labelPause);
      });
    }
  }

  if (!customElements.get('ssl-tstats-toggle')) customElements.define('ssl-tstats-toggle', SslTstatsToggle);
  if (!customElements.get('ssl-tabs')) customElements.define('ssl-tabs', SslTabs);
  if (!customElements.get('ssl-plan-toggle')) customElements.define('ssl-plan-toggle', SslPlanToggle);
})();
